import React from 'react';
import PropTypes from 'prop-types';
import { Dropdown, Icon, FlexRow, H5 } from '@contently/toolkit';

const regions = ['All', 'US', 'Canada'];
export default function Filter({ filterState, setFilterState }) {
  const TriggerButton = () => (
    <FlexRow margin="small">
      <span>
        <H5>{filterState}</H5>
      </span>
      <Icon type="angle-down" />
    </FlexRow>
  );

  const dropDownAction = region => {
    setFilterState(region);
    localStorage.setItem('contentValueRegion', region);
  };

  const dropdownActions = regions.map(region => ({
    name: region,
    action: () => dropDownAction(region),
    disabled: filterState === region
  }));

  return <Dropdown links={dropdownActions} Trigger={TriggerButton} id="filter-trigger" />;
}

Filter.propTypes = {
  filterState: PropTypes.string.isRequired,
  setFilterState: PropTypes.func.isRequired
};



// WEBPACK FOOTER //
// ./app/javascript/app/components/value/filter.jsx